var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.212 10.54c-.326-.302-.602-.57-.824-.79.222-.22.498-.488.824-.79A37.01 37.01 0 0 1 7.28 5.698C10.733 3.313 15.406 1 20.5 1c5.094 0 9.767 2.313 13.22 4.698a37.01 37.01 0 0 1 4.068 3.262c.326.302.602.57.824.79-.222.22-.498.488-.824.79-.96.89-2.35 2.076-4.068 3.262-3.453 2.385-8.126 4.698-13.22 4.698-5.094 0-9.767-2.313-13.22-4.698a37.002 37.002 0 0 1-4.068-3.262Z",
    stroke: "#1E1F23",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F23",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M20.926 18.52v4.527M7.933 15.413l-2.537 2.366M4.378 12.364 1.363 14.08M36.374 12.364l3.015 1.716M11.413 17.346 9.851 20.39M15.98 18l-.603 4.322M33.047 14.414l3.12 3.28M29.53 16.428l2.143 3.988M25.355 17.866l.8 4.456"
  })));
};

export default SvgEyeClosed;